<template>
    <div class="wrap">
        <!--导航栏-->
        <navbar :transparent="isTransparent" activeTo="Connect"></navbar>
        <!--背景-->
        <section class="banner">
            <div class="about-ifree-bg">
                <div class="about-ifree-page">
                    <h1 class="banner-title">{{$t('about_ifree_banner_title')}}</h1>
                    <p class="banner-content">
                        {{$t('about_ifree_banner_page')}} </p>
                </div>
            </div>
        </section>
        <section class="">

        </section>
        <!--清除浮动-->
        <div style="clear: both"></div>
        <!--我们的团队-->
        <section class="ifree-team">
            <div class="ifree-team-wrap">
                <Row>
                    <i-col :lg="12" :md="12" :sm="24" :xs="24">
                        <img src="../../assets/about_us/about-us_pic2@2x.jpg" width="95%">
                    </i-col>
                    <i-col :lg="12" :md="12" :sm="24" :xs="24">
                        <div class="ifree-team-content">
                            <h1 class="font_big">{{$t('about_ifree_ourteam')}}</h1>
                            <p class="font_mid">
                                {{$t('about_ifree_ourteam_content')}}
                            </p>
                        </div>
                    </i-col>
                </Row>
            </div>
        </section>
        <!--我们的目标-->
        <section class="ifree-aim">
            <div class="ifree-aim-wrap">
                <h1 class="font_big">{{$t('about_ifree_mission')}}</h1>
                <p class="font_mid">
                    {{$t('about_ifree_mission_content')}}
                </p>
                <p class="font_mid">
                    {{$t('about_ifree_mission_content1')}}
                </p>
                <div class="ifree-aim-system">
                    <img src="../../assets/about_us/ifree_tc@2x.png" v-if="this.languge == 'tc' ">
                    <img src="../../assets/about_us/ifree_sc@2x.png" v-else-if="this.languge == 'sc' ">
                    <img src="../../assets/about_us/ifree_en@2x.png" v-else-if="this.languge == 'en' ">
                </div>
            </div>
        </section>
        <BackTop>
            <div class="top">
                <img src="../../assets/backtop/top.png">
                <p style="">{{$t('top_btn')}}</p>
            </div>
        </BackTop>
        <a href="http://ifree.ly/support" target="_blank">
            <BackTop :height="100" :bottom="110">
                <div class="top">
                    <img src="../../assets/backtop/service.png">
                    <p>{{$t('Service_btn')}}</p>
                </div>
            </BackTop>
        </a>
    </div>
</template>
<script>
    import $ from 'jquery'
    import navbar from '../Common/Navbar.vue'
    import config from '../../lib/config'
    import Signature from '../../lib/Signature'

    export default {
        components: {
            navbar
        },
        data () {
            return {
                isTransparent: false,
                languge: 'cn'
            }
        },
        mounted () {
            let lang = this.$i18n.locale
            if (lang == 'en-US') {
                this.languge = 'en'
            } else if (lang == 'zh-HK') {
                this.languge = 'tc'
            } else if (lang == 'zh-CN') {
                this.languge = 'sc'
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../scss/_about_ifree.scss";

    /*
      athor:刘志豪 vt@ifreegroup.com;
      date:2017/10/18
    */

</style>



// WEBPACK FOOTER //
// AboutiFREE.vue?48e97632